import React, { useEffect, useRef } from 'react';
import classNames from "../util/classNames";

const PanelContent = (props: { padding?: boolean, autoScroll?: boolean, className?: string, children: Array<React.ReactNode> | React.ReactNode }) => {
  const containerRef: React.MutableRefObject<HTMLDivElement | null> = useRef(null);
  const scrollDuration = 1 * 1000;
  const pauseDelay = 5 * 1000;

  useEffect(() => {
    if (props.autoScroll) {
      const smoothScrollTo = (targetPosition: number) => {
        if (containerRef.current) {
          const scrollableContent = containerRef.current;
          const startPosition = scrollableContent.scrollTop;
          const distance = targetPosition - startPosition;
          let startTime: number;

          const animateScroll = (timestamp: number) => {
            if (!startTime) startTime = timestamp;
            const elapsedTime = timestamp - startTime;
            const progress = Math.min(elapsedTime / scrollDuration, 1);
            scrollableContent.scrollTop = startPosition + distance * progress;

            if (elapsedTime < scrollDuration) {
              requestAnimationFrame(animateScroll); // Weiter animieren, wenn noch nicht vollständig gescrollt
            }
          };

          requestAnimationFrame(animateScroll); // Start der Animation
        }
      };

      const scrollToNextPage = () => {
        if (containerRef.current) {
          const container = containerRef.current;
          const children = Array.from(container.querySelectorAll('.scroll-snap-identifier')); // Direkte Kinder

          let nextChild;
          for (const child of children) {
            if ((child as HTMLElement).offsetTop > (container.scrollTop + container.clientHeight))
              break;
            nextChild = child;
          }

          const childPosition = (nextChild as HTMLElement)?.offsetTop ?? 0; // Position des nächsten Elements im Scrollbereich

          if (container.scrollTop + container.clientHeight >= container.scrollHeight) {
            smoothScrollTo(0);
          } else {
            smoothScrollTo(childPosition);
          }
        }
      };

      const interval = setInterval(scrollToNextPage, pauseDelay + scrollDuration); // Alle 5 Sekunden scrollen
      return () => clearInterval(interval); // Aufräumen
    }
  }, [pauseDelay, props, scrollDuration]);

  return (
    <div
      ref={containerRef}
      className={classNames(
        "flex-1 overflow-hidden relative",
        (props.padding ?? true) ? "px-6 pb-5" : "",
        props.className
      )}
      style={{ maxHeight: "100%" }}
    >
      {props.children}
    </div>
  );
};

export default PanelContent;
